import { CardDeck, Container, Modal as ReactModal, Row } from "react-bootstrap";

import DownloaderCard from "./downloaderCard";

import AndroidLogo from "../../assets/android_logo_color.png";
import IOSLogo from "../../assets/ios_logo_white.png";
import MacOSLogo from "../../assets/macos_logo_white.png";
import WindowsLogo from "../../assets/windows_logo_color.png";

import { FaDesktop, FaMobileAlt } from "react-icons/fa";

import "./downloadsModalStyles.css";

const PLAYSTORE_URL =
  "https://play.google.com/store/apps/details?id=com.widowgames.geopoly&hl=es_AR";
const APPLESTORE_URL = "https://apps.apple.com/ar/app/geopoly/id417575532";
const WINDOWS_URL = "https://dl.patchkit.net/d/42a9ynoe13wi6n4i9rma/direct";
const MACOS_URL = "https://geopoly.io/builds/macos.dmg";

const downloaders = [
  {
    logo: AndroidLogo,
    label: "Google Play",
    icon: <FaMobileAlt />,
    onClick: () => window.open(PLAYSTORE_URL, "_blank"),
  },
  {
    logo: IOSLogo,
    label: "Apple Store",
    icon: <FaMobileAlt />,
    onClick: () => window.open(APPLESTORE_URL, "_blank"),
  },
  {
    logo: WindowsLogo,
    label: "Windows",
    icon: <FaDesktop />,
    onClick: () => window.open(WINDOWS_URL, "_blank"),
  },
  {
    logo: MacOSLogo,
    label: "Mac OS",
    icon: <FaDesktop />,
    onClick: () => window.open(MACOS_URL, "_blank"),
  },
];

const DownloadsModal = ({ displayModal, setDisplayModal }) => (
  <ReactModal
    size="lg"
    className="downloads-modal"
    show={displayModal}
    onHide={() => setDisplayModal(false)}
    centered
  >
    <ReactModal.Header closeButton className="downloads-modal-header">
      <ReactModal.Title className="mx-auto">
        <Row className="justify-content-center">
          <span className="title">
            <span className="yellow mr-2">Download</span>version
          </span>
        </Row>
        <Row className="justify-content-center">
          <span className="subtitle">Select your version to download!</span>
        </Row>
      </ReactModal.Title>
    </ReactModal.Header>
    <ReactModal.Body className="downloads-modal-body px-0 pb-0 pt-2">
      <Container className="downloads-modal-container px-0">
        <Row className="downloads-modal-row mx-auto text-center justify-content-center">
          <CardDeck className="downloads-modal-deck justify-content-center">
            {downloaders.map((downloader, index) => (
              <DownloaderCard
                key={index}
                logo={downloader.logo}
                label={downloader.label}
                icon={downloader.icon}
                onClick={downloader.onClick}
              />
            ))}
          </CardDeck>
        </Row>
      </Container>
    </ReactModal.Body>
  </ReactModal>
);

export default DownloadsModal;
